var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    fill: "#260C6A",
    rx: 18.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1.5,
    y: 1.5,
    stroke: "#fff",
    strokeWidth: 3,
    rx: 18.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F9",
    d: "M24.794 9.604 22.203 9.6c-2.91 0-4.791 1.97-4.791 5.02v2.315h-2.604a.41.41 0 0 0-.408.416v3.354c0 .23.183.416.407.416h2.605v8.463c0 .23.182.416.407.416h3.399a.41.41 0 0 0 .407-.416v-8.463h3.045a.41.41 0 0 0 .407-.416l.002-3.354a.42.42 0 0 0-.12-.294.4.4 0 0 0-.288-.122h-3.046v-1.962c0-.943.22-1.422 1.423-1.422h1.745a.41.41 0 0 0 .407-.417V10.02a.41.41 0 0 0-.406-.416"
  })));
};
export default SvgFacebook;